import React from "react";
import { Controller, useForm } from "react-hook-form";
import InnerHeader from "../../component/shared/innerheader/InnerHeader.js";
import { FormattedMessage, useIntl } from "react-intl";
import ChevronIcon from "svg-icons/chevron-icon.js";
import CustomizedDatePicker from "component/customizedDatePicker/customized-date-picker.js";
import useSWR from "swr";
import { END_POINTS } from "constants/APIConstant.js";
// import LabelLang, { LabelLangString } from "component/LabelLang/label-lang.js";
import fetch from "../../auth/FetchInterceptor.js";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
// import moment from "moment";
import { useSelector } from "react-redux";
import ContentLoading from "component/LoadingComponent/ContentLoading.js";
import CircularProgress from "@mui/material/CircularProgress";
import SnackbarModal from "component/shared/snackbar";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { MutateCacheSWRPartialKey } from "services/SWRPartialKeyService.js";
import { Link } from "react-router-dom";
import { APP_PREFIX_PATH } from "configs/AppConfig.js";
import ReactGA from "react-ga4";

function Profile() {
  const dir = useSelector(({ theme }) => theme.direction);

  const { id } =
    useSelector(({ auth }) => {
      return auth;
    });

  React.useEffect(() => {
    const timeOut = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
    return () => {
      clearTimeout(timeOut);
    };
  }, []);


  ReactGA.initialize(END_POINTS.TRACKING_ID)

  React.useEffect(() => {
    // Send pageview with a custom path
    ReactGA.send({ hitType: "pageview", page: "/profile", title: "Profile Page" });
  }, []);


  const formSchema = Yup.object().shape({
    firstName: Yup.string()
      .matches(/^\S*$/, {
        message: <FormattedMessage id="first-name-validation" />,
      })
      .matches(/^[a-zA-Z\u0600-\u06FF,-][\sa-zA-Z\u0600-\u06FF,-]*$/, {
        message: <FormattedMessage id="first-name-validation" />,
      })
      .min(2)
      .max(20),
    lastName: Yup.string()
      .matches(/^\S*$/, {
        message: <FormattedMessage id="last-name-validation" />,
      })
      .matches(/^[a-zA-Z\u0600-\u06FF,-][\sa-zA-Z\u0600-\u06FF,-]*$/, {
        message: <FormattedMessage id="last-name-validation" />,
      })
      .min(2)
      .max(20),
    phoneNumber: Yup.string()
      .matches(/^[0-9]*$/)
      .max(15, <FormattedMessage id="mobile-max-validation" />)
      .min(7, <FormattedMessage id="mobile-min-validation" />),
    address: Yup.string().required(
      <FormattedMessage id="address-required-validation" />
    ),
    birthDate: Yup.date()
      .required(<FormattedMessage id="dob-required-validation" />)
      .min("1900-01-01", <FormattedMessage id="min-date-value" />)
      .max(
        new Date().toJSON().slice(0, 10),
        <FormattedMessage id="max-date-value" />
      ),
  });

  const formOptions = {
    resolver: yupResolver(formSchema),
    defaultValues: {
      id: id,
    },
  };
  const { control, register, setValue, handleSubmit, reset, formState } =
    useForm(formOptions);
  const { errors } = formState;

  const getData = useSWR({
    url: END_POINTS.GET_USER_DATA,
  });

  const [data, setData] = React.useState();

  React.useEffect(() => {
    let timeOut = setTimeout(() => {
      getData.mutate();
      if (getData?.data?.data && getData?.data?.data !== null) {
        setValue("birthDate", getData?.data?.data?.birthDate.slice(0,10));
        setValue("phoneNumber", getData?.data?.data?.phoneNumber);
        setValue("firstName", getData?.data?.data?.firstName);
        setValue("lastName", getData?.data?.data?.lastName);
        setValue("address", getData?.data?.data?.address);
        setValue("email", getData?.data?.data?.email);
        setValue("username", getData?.data?.data?.username);
      }
    }, 0);
    return () => {
      clearTimeout(timeOut);
    };
  }, [getData?.data]);

  const intl = useIntl();
  const onSubmit = (data) => {
    setData(JSON.stringify(data));
    updateData(data);
  };

  const [show, setShow] = React.useState(false);
  const handleShow = () => {
    setShow(true);
  };
  const handleClose = () => {
    setShow(false);
  };

  const [success, setSuccess] = React.useState(false);
  const [showMessage, setShowMessage] = React.useState("");
  const [buttonSpinner, setButtonSpinner] = React.useState(false);

  async function updateData(data) {
    setButtonSpinner(true);

    const dateString = data.birthDate;
    const date = new Date(dateString);

    // Handle cases where setting date might cause overflow (e.g., 31st of a month)
    if (date.getDate() === new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate()) {
    // If current date is the last day of the month, set to the first day of the next month.
    date.setDate(1);
    date.setMonth(date.getMonth() + 1);
    } else {
    // Otherwise, simply set the desired day.
    date.setDate(data.birthDate.getDate() + 1);
    }
    const newDateString = date?.toISOString();

    let updateData = {
      id: id,
      firstName: data.firstName,
      lastName: data.lastName,
      phoneNumber: data.phoneNumber,
      address: data.address,
      birthDate: newDateString,
    };

    return await fetch
      .put(END_POINTS.UPDATE_USER_DATA, updateData)
      .then((res) => {
        setShowMessage(intl.formatMessage({ id: "successfully-update" }));
        setSuccess(true);
        setButtonSpinner(false);
        handleShow();
        setTimeout(() => {
          handleClose();
          MutateCacheSWRPartialKey(END_POINTS.GET_USER_DATA)
        }, 2000);
      })
      .catch((e) => {
        setShowMessage(e.response.data.message);
        setSuccess(false);
        setButtonSpinner(false);
        handleShow();
      });
  }

  return (
    <ContentLoading isLoading={getData.isLoading}>
      <div className="subscribe">
        <InnerHeader
          breadcrumb={[
            {
              title: intl.formatMessage({ id: "profile" }),
              clickClass: true,
            },
          ]}
          title={intl.formatMessage({ id: "profile-data" })}
          route={"../profile"}
        />
        <div className="container py-5">
          <div className="row">
            <div className="col-12 col-lg-9">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-label row">
                  <div className="col-lg-4">
                    <label>
                      <FormattedMessage id="username" />:
                    </label>
                  </div>
                  <div className="col-lg-8">
                    <div
                        className={`form-label-container`}
                    >
                      <Controller
                        control={control}
                        name="username"
                        render={({ field }) => (
                            <>
                                <input
                                    type="text"
                                    {...register("username")}
                                    value={field.value}
                                    className={`form-control text-black-50`}
                                    disabled
                                />
                                <span>*</span>
                            </>
                        )}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-label row">
                  <div className="col-lg-4">
                    <label>
                      <FormattedMessage id="email" />:
                    </label>
                  </div>
                  <div className="col-lg-8">
                    <div
                        className={`form-label-container`}
                    >
                      <Controller
                        control={control}
                        name="email"
                        render={({ field }) => (
                            <>
                                <input
                                    type="text"
                                    {...register("email")}
                                    value={field.value}
                                    className={`form-control text-black-50`}
                                    disabled
                                />
                                <span>*</span>
                            </>
                        )}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-label row">
                  <div className="col-lg-4">
                    <label>
                      <FormattedMessage id="fname" />:
                    </label>
                  </div>
                  <div className="col-lg-8">
                    <div
                      className={`form-label-container ${
                        errors?.firstName?.message ? "mb-3" : ""
                      }`}
                    >
                      <Controller
                        control={control}
                        name="firstName"
                        render={({ field }) => (
                            <>
                                <input
                                    type="text"
                                    {...register("firstName")}
                                    value={field.value}
                                    className={`form-control ${
                                    errors.firstName ? "is-invalid" : ""
                                    }`}
                                />
                                <span>*</span>
                            </>
                        )}
                      />
                    </div>
                    {errors?.firstName?.message && (
                      <alert className="alert alert-danger py-1">
                        {errors?.firstName?.message}
                      </alert>
                    )}
                  </div>
                </div>
                <div className="form-label row">
                  <div className="col-lg-4">
                    <label>
                      <FormattedMessage id="lname" />:{" "}
                    </label>
                  </div>
                  <div className="col-lg-8">
                    <div
                      className={`form-label-container ${
                        errors?.lastName?.message ? "mb-3" : ""
                      }`}
                    >
                      <Controller
                        control={control}
                        name="lastName"
                        render={({ field }) => (
                            <>
                                <input
                                    type="text"
                                    {...register("lastName")}
                                    value={field.value}
                                    className={`form-control ${
                                    errors.lastName ? "is-invalid" : ""
                                    }`}
                                />
                                <span>*</span>
                            </>
                        )}
                      />
                    </div>
                    {errors?.lastName?.message && (
                      <alert className="alert alert-danger py-1">
                        {errors?.lastName?.message}
                      </alert>
                    )}
                  </div>
                </div>
                <div className="form-label row">
                  <div className="col-lg-4">
                    <label>
                      <FormattedMessage id="dob" />:
                    </label>
                  </div>
                  <div className="col-lg-8">
                    <div
                      className={`form-label-container ${
                        errors?.birthDate?.message ? "mb-3" : ""
                      }`}
                    >
                      <Controller
                        control={control}
                        name="birthDate"
                        render={({ field }) => (
                          <CustomizedDatePicker
                            dateFormat="dd/MM/yyyy"
                            placeholderText={intl.formatMessage({
                              id: "select-date",
                            })}
                            onChange={(e) => field.onChange(e.target.value)}
                            value={field.value}
                            min={new Date("1900-01-01").toJSON().slice(0, 10)}
                            max={new Date().toJSON().slice(0, 10)}
                            // selected={field.value}
                            // showIcon={true}
                            className={`form-control ${
                              errors.birthDate ? "is-invalid" : ""
                            }`}
                          />
                        )}
                      />
                      <span>*</span>
                    </div>
                    {errors?.birthDate?.message && (
                      <alert className="alert alert-danger py-1">
                        {errors?.birthDate?.message}
                      </alert>
                    )}
                  </div>
                </div>
                <div className="form-label row">
                  <div className="col-lg-4">
                    <label>
                      {" "}
                      <FormattedMessage id="address" />:
                    </label>
                  </div>
                  <div className="col-lg-8">
                    <div
                      className={`form-label-container ${
                        errors?.address?.message ? "mb-3" : ""
                      }`}
                    >
                      <Controller
                        control={control}
                        name="address"
                        render={({ field }) => (
                            <>
                                <input
                                    type="text"
                                    {...register("address")}
                                    value={field.value}
                                    className={`form-control ${
                                    errors.address ? "is-invalid" : ""
                                    }`}
                                />
                                <span>*</span>
                            </>
                        )}
                      />
                    </div>
                    {errors?.address?.message && (
                      <alert className="alert alert-danger py-1">
                        {errors?.address?.message}
                      </alert>
                    )}
                  </div>
                </div>
                <div className="form-label row">
                  <div className="col-lg-4">
                    <label>
                      <FormattedMessage id="mobile" />:
                    </label>
                  </div>
                  <div className="col-lg-8">
                    <div className="row">
                      <div className="col-lg-12 position-relative">
                        <div
                          className={`form-label-container mobile ${
                            errors?.phoneNumber?.message ? "mb-3" : ""
                          }`}
                          dir={"ltr"}
                        >
                          {/* <input
                            {...register("countryCode")}
                            className={`form-control ${
                              errors.countryCode ? "is-invalid" : ""
                            }`}
                          /> */}
                          <Controller
                            control={control}
                            name="phoneNumber"
                            render={({ field: { ref, ...field } }) => (
                              <PhoneInput
                                {...field}
                                inputExtraProps={{
                                  ref,
                                  required: true,
                                  autoFocus: true,
                                }}
                                inputStyle={{
                                  direction: "ltr",
                                }}
                                // dropdownStyle={{
                                //   direction:
                                //     currentLocale == "ar" ? "rtl" : "ltr",
                                // }}

                                // searchStyle={{
                                //   paddingInlineEnd:
                                //     currentLocale == "ar" ? "40px" : "0px",
                                //   paddingInlineStart:
                                //     currentLocale == "ar" ? "0px" : "40px",
                                // }}
                                country={"eg"}
                                placeholder="+201121221501"
                                className={`form-control ${
                                  errors.phoneNumber ? "is-invalid" : ""
                                }`}
                              />
                            )}
                          />
                        </div>
                        <span className=" position-absolute" style={{top: '10px', insetInlineEnd: '0px', color: 'red'}}>*</span>
                      </div>
                    </div>
                    <div className="col-12 mb-3">
                      {errors?.phoneNumber?.message && (
                        <alert className="alert alert-danger py-1">
                          {errors?.phoneNumber?.message}
                        </alert>
                      )}
                    </div>
                    <div className="col-12">
                      {errors?.countryCode?.message && (
                        <alert className="alert alert-danger py-1">
                          {errors?.countryCode?.message}
                        </alert>
                      )}
                    </div>
                  </div>
                </div>

                <div className="text-center">
                  <button
                    type="submit"
                    className="main-btn"
                    style={{ marginInlineStart: "auto" }}
                  >
                    <span>
                      {buttonSpinner ? (
                        <span>
                          <CircularProgress sx={{ color: "#fff" }} size={26} />
                        </span>
                      ) : (
                        <>
                          <span style={{ marginInlineEnd: "0.5rem" }}>
                            <FormattedMessage id="confirm" />
                          </span>
                          <ChevronIcon width={12} height={12} color="#FFFFFF" />
                        </>
                      )}
                    </span>
                  </button>
                </div>
                <div className={`mt-4 ${dir === 'rtl' ? 'text-start' : 'text-end'}`}>
                    <Link to={`${APP_PREFIX_PATH}/resetPass/${id}`}>
                        <span style={{ color: "var(--main-color)"}}>
                        <u>
                            <FormattedMessage id="resetPass" />
                        </u>
                        </span>
                    </Link>
                </div>

                <SnackbarModal
                  open={show}
                  onClose={handleClose}
                  severity={success ? "success" : "error"}
                  message={showMessage}
                />
              </form>
            </div>
          </div>
        </div>
      </div>
    </ContentLoading>
  );
}

export default Profile;
